import { CircularProgress } from "@mui/material";
import ChatSection from "components/admin/ChatSection";
import CustomBtn from "components/admin/CustomBtn";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import apis from "services";
import { toTitleCase } from "utils/toTitleCase";

const TicketDetails = () => {
  const items = ["open", "closed", "in process"];

  const { ticketId } = useParams();
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [ticket, setTicket] = useState("");
  const [status, setStatus] = useState("");
  const [comment, setComment] = useState("");

  const handleGetTicketById = async () => {
    try {
      setLoading(true);

      const res = await apis.getTicketById(ticketId);
      if (res?.data?.status) {
        setTicket(res.data.data);
        setStatus(ticket.status);
      } else {
        toast.error(res.data.message);
      }
    } catch (e) {
      toast.error(e.message || "Something went wrong! Please try again");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetTicketById();
  }, [ticketId]);

  const handleCommentChange = (e) => {
    e.preventDefault();

    const sanitizedValue = e.target.value.replace(/[\r\n]+/g, "");
    setComment(sanitizedValue);
  };

  const updateTicket = async (e) => {
    e.preventDefault();

    try {
      setBtnLoading(true);
      const payload = { status: status || ticket.status, comment };
      if (status !== ticket.status && !comment) {
        payload.comment = `Status updated from '${ticket.status}' to '${status}'`;
      }
      const res = await apis.updateTicketById(payload, ticketId);
      if (res?.data?.status) {
        setTicket(res?.data?.data);
        setComment("");
        setStatus(res.data.data.status);
      } else {
        toast.error(res.data.message || "Something went wrong, Please wait!");
      }
    } catch (e) {
      toast.error(e.message || "Something went wrong, Please wait!");
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <div className="tickets-tab-container">
      {loading ? (
        <div>
          <div className="content-loader">
            <CircularProgress color="error" />
          </div>
        </div>
      ) : (
        <>
          <div className="ticket-input">
            <label htmlFor="status" className="my-label">
              Status
            </label>
            <select name="status" onChange={(e) => setStatus(e.target.value)}>
              {items.map((item, index) => (
                <option
                  key={index}
                  value={item}
                  selected={item === ticket.status}
                >
                  {toTitleCase(item)}
                </option>
              ))}
            </select>
          </div>

          <div className="text-area-container">
            <label htmlFor="comment" className="my-label">
              Comment
            </label>
            <textarea
              name="comment"
              id="comment"
              rows={10}
              placeholder="Write your comments here"
              value={comment}
              onChange={handleCommentChange}
            />
          </div>

          <div className="flex-center">
            <CustomBtn
              title={"Action"}
              onClickHandler={updateTicket}
              disabled={btnLoading || loading}
              loading={btnLoading}
            />
          </div>

          <div className="ticket-desc-container">
            <p>
              <b>Subject: </b> {ticket?.subject}
            </p>
            {ticket?.description ? (
              <p>
                <b>Description: </b>
                {ticket.description}
              </p>
            ) : (
              <p className="placeholder-class">No Description</p>
            )}
            <p>
              <b>Name: </b> {ticket?.userId?.name}
            </p>
          </div>

          <ChatSection data={ticket?.comments} />
        </>
      )}
    </div>
  );
};

export default TicketDetails;
